import ActivationRequiredError from './ActivationRequiredError'

export default ActivationRequiredError
